"use strict";

module.exports = "<svg version=\"1.1\" class=\"dibsvg-svg dibsvg-arrow-left\" viewBox=\"-8.5 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <path d=\"M14,32c-0.3,0-0.6-0.1-0.8-0.3l-13-15c-0.3-0.4-0.3-0.9,0-1.3l13-15c0.4-0.4,1-0.5,1.4-0.1 c0.4,0.4,0.5,1,0.1,1.4L2.3,16l12.4,14.3c0.4,0.4,0.3,1-0.1,1.4C14.4,31.9,14.2,32,14,32z\" />\n</svg>";


//////////////////
// WEBPACK FOOTER
// ./~/dibs-vg/dist/templateString/arrow-left.js
// module id = 1670
// module chunks = 4 7